{
"Noord-Holland": [52.662809, 4.911493],
"Groningen": [53.260349, 6.73187],
"Overijssel": [52.444337, 6.443138],
"Zeeland": [51.477968, 3.815008],
"Friesland": [53.15224, 5.692019],
"Drenthe": [52.862279, 6.61852],
"Flevoland": [52.550153, 5.514616],
"Utrecht": [52.096552, 5.173689],
"Zuid-Holland": [51.938635, 4.461686],
"Limburg": [51.20788, 5.933197],
"Gelderland": [52.061737, 5.938646],
"Noord-Brabant": [51.561723, 5.18513]
}